module.exports = __webpack_public_path__ + "img/fmk-circle.0a43e8ab.png";